module.exports = __webpack_public_path__ + "static/media/12C.70723963.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/12C.svg
// module id = 42
// module chunks = 0